import React from "react"
import { StaticImage } from "gatsby-plugin-image"

const ImageMO24 = () => {

  return (
    <StaticImage
      src="../../images/JPG-MALE-LOOK002-4.jpg"
      
      alt="Reserved avatar"
    />
  )
}

export default ImageMO24
